'use client';

import { T } from '@/i18n/LocaleProvider';
import Box from '@mui/material/Box';
import { PageSection, PlanCard } from '@/components';
import { useStaggerIn } from '@/hooks/useStaggerIn';
import { PRICED_PLANS } from '@/libs/content/plans';

export default function Plans() {
  const gridRef = useStaggerIn({ y: 24 });

  return (
    <PageSection
      id="planes"
      eyebrow="08 / Planes"
      title={
        <>
          <T>Tres niveles. </T>
          <Box component="br" sx={{ display: { xs: 'none', sm: 'block' } }} />
          <span className="accent">
            <T>Cero</T>
          </span>
          <T> sorpresas.</T>
        </>
      }
      lede="Elige tu plan, paga en pesos o USD. Sin escalado por tamaño de empresa. Cancela cuando quieras."
    >
      <Box
        ref={gridRef}
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: 2,
          alignItems: 'stretch',
        }}
      >
        {PRICED_PLANS.map((plan) => (
          <PlanCard key={plan.id} {...plan} />
        ))}
      </Box>
    </PageSection>
  );
}
